import themes from '../config/themes';

/**
 * Detects the tenant/brand based on the current URL hostname
 * @returns {string} 'redwoodseed' or 'initio'
 */
export function getTenantFromUrl() {
  // Check for query parameter override (useful for local testing)
  // Only works in development mode to avoid production issues
  // if (process.env.NODE_ENV === 'development') {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const tenantOverride = urlParams.get('tenant');
  //   if (tenantOverride && themes[tenantOverride]) {
  //     localStorage.setItem('tenant', tenantOverride);
  //     return tenantOverride;
  //   }
  // }
  if (process.env.NODE_ENV === 'development') {
    const urlParams = new URLSearchParams(window.location.search);
    let tenantOverride = urlParams.get('tenant');
    // redwoodvaluation = same branding as redwoodseed (domain alias)
    if (tenantOverride === 'redwoodvaluation') tenantOverride = 'redwoodseed';
    if (tenantOverride && themes[tenantOverride]) {
      localStorage.setItem('tenant', tenantOverride);
      return tenantOverride;
    }
  }
  const hostname = window.location.hostname.toLowerCase();
  
  // Check for redwoodseed in the domain
  // if (hostname.includes('redwoodseed')) {
  //   localStorage.setItem('tenant', 'redwoodseed');
  //   return 'redwoodseed';
  // }
  if (hostname.includes('redwoodseed') || hostname.includes('redwoodvaluation')) {
    localStorage.setItem('tenant', 'redwoodseed');
    return 'redwoodseed';
  }
  // Check localStorage for previously saved tenant
  const savedTenant = localStorage.getItem('tenant');
  if (savedTenant && themes[savedTenant]) {
    return savedTenant;
  }
  
  // Default to initio
  localStorage.setItem('tenant', 'initio');
  return 'initio';
}

/**
 * Gets the theme configuration for a specific tenant
 * @param {string} tenant - The tenant identifier ('initio' or 'redwoodseed')
 * @returns {object} Theme configuration object
 */
export function getThemeConfig(tenant) {
  return themes[tenant] || themes.initio;
}

